import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import { IconContext } from '../context';

function IconQuestionCircleComponent(iconProps, ref) {
  const _useContext = useContext(IconContext),
        _useContext$prefixCls = _useContext.prefixCls,
        prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  const spin = iconProps.spin,
        className = iconProps.className;
  const props = {
    "aria-hidden": true,
    focusable: false,
    ref,
    ...iconProps,
    className: `${className ? className + ' ' : ''}${prefixCls}-icon ${prefixCls}-icon-question-circle`
  };

  if (spin) {
    props.className = `${props.className} ${prefixCls}-icon-loading`;
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M42 24c0 9.941-8.059 18-18 18S6 33.941 6 24 14.059 6 24 6s18 8.059 18 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.006 31v4.008m0-6.008L24 28c0-3 3-4 4.78-6.402C30.558 19.195 28.288 15 23.987 15c-4.014 0-5.382 2.548-5.388 4.514v.465"
  }));
}

const IconQuestionCircle = /*#__PURE__*/React.forwardRef(IconQuestionCircleComponent);
IconQuestionCircle.defaultProps = {
  isIcon: true
};
IconQuestionCircle.displayName = 'IconQuestionCircle';
export default IconQuestionCircle;